import { APP_URL } from '../../constants';
import { useLanguage } from '../../i18n/LanguageContext';

function RewardsSection() {
    const { t } = useLanguage();

    return (
        <section className="home-sec" id="rewards">
            <div className="wrap reward-callout rv">
                <div>
                    <span className="eyebrow">{t.rewardsEyebrow}</span>
                    <h2>{t.rewardsTitle}</h2>
                </div>
                <p>{t.rewardsLead}</p>
                <a className="btn btn-ghost btn-sm" href={APP_URL}>
                    {t.exploreOffers}
                </a>
            </div>
        </section>
    );
}

export default RewardsSection;
